import React, { Component } from 'react';
import { Segment, Container, Table } from 'semantic-ui-react';
import moment from 'moment';
import _ from 'lodash';
import TypeList from '../filter3.json';
import { connect } from 'react-redux';
import Page from '../../components/Page';
import { Chart } from 'react-google-charts';
import { withTranslation } from 'react-i18next';
import FilterComponent from '../../components/FilterComponent';

class Analytic extends Component {
	state = {
		filterType: false,
		filterAgent: false,
		loading: true,
		start_date: this.props.start_date,
		end_date: this.props.end_date,
		today: moment(),
		group: ['agent'],
		value: _.map(TypeList, (it) => {
			return it;
		}),
		pid: this.props.product.live.settings.live.token,
		phonepid: this.props.product.live.settings.wapi_pid || this.props.product.live.id,
		selectedAgent: 'all',
		selectedDate: 'daily',
		productAgentList: [],
		botId: '',
		tableStart: 0,
		tableEnd: 20,
		dataloading: true,
		selectedWatsonsGroup: 'all',
		selectedTeam: 'all',
	};
	_i = 0;
	componentDidUpdate(oldProps, oldState) {
		const check_list = [/* 'start_date', 'end_date',  */ 'selectedAgent', 'newDataToggle'];
		for (let i = 0; i < check_list.length; i++) {
			const key = check_list[i];
			let timer;
			if (key === 'start_date' || key === 'end_date' || key === 'newDataToggle') {
				if (this.props[key] !== oldProps[key]) {
					window.clearTimeout(timer);
					timer = setTimeout(() => this.getData(), 3000);
					break;
				}
			}
			if (this.state[key] !== oldState[key]) {
				window.clearTimeout(timer);
				timer = setTimeout(() => this.getData(), 3000);
				break;
			}
		}
	}
	componentDidMount() {
		let { pid, phonepid, end_date, start_date } = this.state;
		let product = this.props.product.live;
		let isMock = product && product.settings.mock_analytic;
		let token = product && product.settings && product.settings.wapi_token;
		/* fetch('/api/live/agent/list')
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				this.setState({
					productAgentList: _.filter(data.agents, function (it) {
						return it.role !== 'viewer';
					}),
				});
			}); */
		fetch('/api/dahi/message/getLiveChat', {})
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				this.setState({
					productAgentList:
						data.result &&
						data.result.agents &&
						_.filter(data.result.agents, function (it) {
							return it.type !== 'viewer';
						}),
					productOldAgentList: data.result && data.result.old_agents,
					botId: data.result && data.result.bot.bid,
					bot_id: data.result && data.result.bot.id,
					chat_groups: data.result && data.result.staticOptions && data.result.staticOptions.groups,
					chat_teams: data.result && data.result.staticOptions && data.result.staticOptions.teams,
					agent_statuses: data.result && data.result.staticOptions && data.result.staticOptions.agent_statuses,
				});
			});
		fetch('https://log.yapaytech.com/live/timeline/takeConversationStatus ', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				start_date: start_date,
				end_date: end_date,
				pid: pid,
			}),
		})
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				let newData = _.map(data, (it) => ({
					agent: it.agent,
					last_status: it.last_status,
					changes: it.changes
						? _.filter(
								_.map(it.changes, function (a, i) {
									if (i === 0) {
										return a;
									} else {
										if (it.changes[i - 1].status !== it.changes[i].status) {
											return a;
										}
									}
								}),
								function (o) {
									return o && o.date;
								}
						  )
						: [],
				}));
				this.setState({ takeConversationStatus: newData });
			});
		fetch('https://log.yapaytech.com/live/timeline/agentstatus ', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				start_date: start_date,
				end_date: end_date,
				pid: pid,
			}),
		})
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				let newData = _.map(data, (it) => ({
					agent: it.agent,
					last_status: it.last_status,
					changes: it.changes
						? _.filter(
								_.map(it.changes, function (a, i) {
									if (i === 0) {
										return a;
									} else {
										if (it.changes[i - 1].status !== it.changes[i].status) {
											return a;
										}
									}
								}),
								function (o) {
									return o && o.date;
								}
						  )
						: [],
				}));
				this.setState({ agentStatus: newData, loading: false, agentLength: data.length });
			});
	}
	handleFilterChange = (e, { value }) => {
		this.setState(
			{
				selectedAgent: value,
				selectedWatsonsGroup: value !== 'all' ? 'all' : this.state.selectedWatsonsGroup,
			},
			() => {
				this.getData();
			}
		);
	};
	handleFilterCheck = (value) => {
		let array = this.state.value || [];
		let exists = _.find(array, value);
		let valueArr = exists ? _.filter(array, (it) => it !== value) : _.concat([], array, value);
		this.setState({ value: valueArr }, () => {
			this.getData();
		});
	};

	onFilterChange = (name, value) => {
		this.setState({ [name]: value }, () => {
			this.getData();
		});
	};
	async getData() {
		this.setState({ loading: true });
		let { start_date, end_date } = this.props;
		let product = this.props.product.live;
		let { pid, phonepid } = this.state;
		let token = product && product.settings && product.settings.wapi_token;
		this.setState({ loading: true, dataloading: true });
		if (token) {
			await fetch('https://log.yapaytech.com/analytic/timeline/phone', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify({
					start_date: start_date,
					end_date: end_date,
					pid: phonepid,
				}),
			})
				.then((response) => {
					return response.json();
				})
				.then((data) => {
					let newData = _.map(data, (it) => ({
						phone: it.phone,
						last_status: it.last_status,
						changes: it.changes
							? _.filter(
									_.map(it.changes, function (a, i) {
										if (i === 0) {
											return a;
										} else {
											if (it.changes[i - 1].status !== it.changes[i].status) {
												return a;
											}
										}
									}),
									function (o) {
										return o && o.date;
									}
							  )
							: [],
					}));

					this.setState({ phoneStatus: newData, phoneLength: data.length, loaing: false });
				});
		}
		fetch('https://log.yapaytech.com/live/timeline/takeConversationStatus ', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				start_date: start_date,
				end_date: end_date,
				pid: pid,
			}),
		})
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				let newData = _.map(data, (it) => ({
					agent: it.agent,
					last_status: it.last_status,
					changes: it.changes
						? _.filter(
								_.map(it.changes, function (a, i) {
									if (i === 0) {
										return a;
									} else {
										if (it.changes[i - 1].status !== it.changes[i].status) {
											return a;
										}
									}
								}),
								function (o) {
									return o && o.date;
								}
						  )
						: [],
				}));
				this.setState({ takeConversationStatus: newData });
			});
		await fetch('https://log.yapaytech.com/live/timeline/agentstatus', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				start_date: start_date,
				end_date: end_date,
				pid: pid,
			}),
		})
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				let newData = _.map(data, (it) => ({
					agent: it.agent,
					last_status: it.last_status,
					changes: _.filter(
						_.map(it.changes, function (a, i) {
							if (i === 0) {
								return a;
							} else {
								if (it.changes[i - 1].status !== it.changes[i].status) {
									return a;
								}
							}
						}),
						function (o) {
							return o && o.date;
						}
					),
					changesno: _.map(it.changes, function (a, i) {
						if (i === 0) {
							return a;
						} else {
							if (it.changes[i - 1].status !== it.changes[i].status) {
								return a;
							}
						}
					}),
				}));

				this.setState({ agentStatus: newData, loading: false, agentLength: data.length, dataloading: false });
			});
	}
	dateChange = ({ selection }) => {
		let start_date = moment(selection.startDate).startOf('day');
		let end_date = moment(selection.endDate);
		if (end_date.format('YYYY-MM-DD') !== this.state.today.format('YYYY-MM-DD')) {
			end_date = end_date.endOf('day');
		} else {
			end_date = moment();
		}
		this.setState({ start_date, end_date });
	};
	miliToSec(value) {
		const minutes = value / 1000 / 60;
		return this.formatMinutesToTime(minutes);
	}
	formatMinutesToTime(minutes, product) {
		const totalSeconds = Math.round(minutes * 60);

		const hours = Math.floor(totalSeconds / 3600);
		const remainingSeconds = totalSeconds % 3600;
		const minutesPart = Math.floor(remainingSeconds / 60);
		const secondsPart = remainingSeconds % 60;

		const formattedHours = String(hours).padStart(2, '0');
		const formattedMinutes = String(minutesPart).padStart(2, '0');
		const formattedSeconds = String(secondsPart).padStart(2, '0');

		return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
	}
	render() {
		let { start_date, end_date, t, i18n } = this.props;
		const { selectedWatsonsGroup, selectedTeam, selectedAgent, productAgentList, chat_groups, chat_teams } = this.state;
		//let isMock = product.live && product.live.settings.mock_analytic;
		const watsons_groups = [{ text: t('allGroups'), value: 'all' }];
		if (chat_groups && chat_groups.length) {
			_.each(chat_groups, (it) =>
				watsons_groups.push({
					text: it.label,
					value: it.id,
					id: it.id,
					key: it.id,
				})
			);
		}

		let teams = [
			{
				text: t('allTeams'),
				value: 'all',
				id: 'all',
				key: 'all',
			},
		];

		let dropAgentList = _.map(productAgentList, (agent) => ({
			text: agent.developer || agent.name,
			value: agent.id,
			key: agent.id,
		}));
		dropAgentList = [{ text: t('allAgent'), value: 'all', key: 'all' }, ...dropAgentList];

		if (this.state.loading)
			return (
				<Container>
					<Segment style={{ marginBottom: '20px' }}>
						<Page.Loader></Page.Loader>
					</Segment>
				</Container>
			);
		let timelineData = [],
			phoneTimeline = [],
			instagramTimeline = [];
		let colors = {
			available: '#4ed34e',
			busy: '#d34e4e',
			unknown: '#d4d4d5',
			other: '#F4B400',
		};

		let _start = moment(start_date);
		let _end = moment() > moment(end_date) ? moment(end_date) : moment();
		let agentList = _.concat(this.state.productAgentList, this.props.user);
		let displayName = this.props.displayName === 'developer' ? 'email' : 'name';
		let phonesArray = _.intersectionBy(this.state.phoneStatus, this.state.phones, 'phone');
		let instagramsArray = _.intersectionBy(this.state.phoneStatus, this.state.instagrams, 'phone');
		let new_timeline = [];
		/* console.log('this.state.agentStatus', agentList); */
		let agent_total_status = [];
		let agent_statuses = this.state.agent_statuses;
		_.each(this.state.agentStatus, function (it, s) {
			let name =
				(_.find(agentList, function (ag) {
					return ag.id === it.agent;
				}) &&
					_.find(agentList, function (ag) {
						return ag.id === it.agent;
					})[displayName]) ||
				(_.find(agentList, function (ag) {
					return ag.id === it.agent;
				}) &&
					_.find(agentList, function (ag) {
						return ag.id === it.agent;
					}).developer);
			if (name) {
				if (it.changes && it.changes.length) {
					new_timeline.push({ name, ...it });
					_.each(it.changes, (a, i) => {
						let start = moment(a.date);
						let end = it.changes[i + 1] && it.changes[i + 1].date ? moment(it.changes[i + 1].date) : _end;

						if (i === 0 && start > _start) {
							let tooltip = moment.duration(start.diff(_start)).humanize();
							if (start.diff(_start))
								agent_total_status.push({
									agent: it.agent,
									name: name || '',
									status: it.last_status,
									time: start.diff(_start, 'ms'),
								});

							timelineData.push([
								name || '' + it.agent,
								(it.last_status && t('' + it.last_status)) || t('unknown'),
								it.last_status ? colors[it.last_status] || colors.other : colors.unknown,
								`${t('status')}: ${(it.last_status && t('' + it.last_status)) || t('unknown')} <br/>${t('agent')}: ${
									name || '' + it.agent
								}<br/>${t('duration')}: ${tooltip}<br/>${t('start')}: ${moment(_start).format('DD-MM HH:mm')}<br/>${t('end')}: ${moment(
									start
								).format('DD-MM HH:mm')}`,
								_start,
								start,
							]);
						}
						let tooltip = moment.duration(end.diff(start)).humanize();

						if (end.diff(start))
							agent_total_status.push({
								agent: it.agent,
								name: name || '',
								status: a.status,
								time: end.diff(start, 'ms'),
							});
						timelineData.push([
							name || '' + it.agent,
							t('' + a.status),
							a.status ? colors[a.status] || colors.other : colors.unknown,
							`${t('status')}: ${t('' + a.status)} <br/>${t('agent')}: ${name || '' + it.agent}<br/>${t('duration')}: ${tooltip}<br/>${t(
								'start'
							)}: ${moment(start).format('DD-MM HH:mm')}<br/>${t('end')}: ${moment(end).format('DD-MM HH:mm')}`,
							start,
							end,
						]);
					});
				} else {
					let tooltip = moment.duration(_end.diff(_start)).humanize();
					if (_end.diff(_start))
						agent_total_status.push({
							agent: it.agent,
							name: name || '',
							status: it.last_status,
							time: _end.diff(_start, 'ms'),
						});
					timelineData.push([
						name || '' + it.agent,
						t('' + it.last_status),
						it.last_status ? colors[it.last_status] || colors.other : colors.unknown,
						,
						`${t('status')}: ${t('' + it.last_status)} <br/>${t('agent')}: ${name || '' + it.agent}<br/>${t('duration')}: ${tooltip}<br/>${t(
							'start'
						)}: ${moment(_start).format('DD-MM HH:mm')}<br/>${t('end')}: ${moment(_end).format('DD-MM HH:mm')}`,
						_start,
						_end,
					]);
				}
			}
		});
		_.each(this.state.takeConversationStatus, function (it, s) {
			let name =
				(_.find(agentList, function (ag) {
					return ag.id === it.agent;
				}) &&
					_.find(agentList, function (ag) {
						return ag.id === it.agent;
					})[displayName]) ||
				(_.find(agentList, function (ag) {
					return ag.id === it.agent;
				}) &&
					_.find(agentList, function (ag) {
						return ag.id === it.agent;
					}).developer);
			if (name) {
				if (it.changes && it.changes.length) {
					new_timeline.push({ name, ...it });
					_.each(it.changes, (a, i) => {
						let start = moment(a.date);
						let end = it.changes[i + 1] && it.changes[i + 1].date ? moment(it.changes[i + 1].date) : _end;

						if (i === 0 && start > _start) {
							let tooltip = moment.duration(start.diff(_start)).humanize();
							if (start.diff(_start))
								agent_total_status.push({
									agent: it.agent,
									name: name || '',
									status: it.last_status,
									time: start.diff(_start, 'ms'),
								});

							timelineData.push([
								name || '' + it.agent,
								(it.last_status && t('' + it.last_status)) || t('unknown'),
								it.last_status ? colors[it.last_status] || colors.other : colors.unknown,
								`${t('status')}: ${(it.last_status && t('' + it.last_status)) || t('unknown')} <br/>${t('agent')}: ${
									name || '' + it.agent
								}<br/>${t('duration')}: ${tooltip}<br/>${t('start')}: ${moment(_start).format('DD-MM HH:mm')}<br/>${t('end')}: ${moment(
									start
								).format('DD-MM HH:mm')}`,
								_start,
								start,
							]);
						}
						let tooltip = moment.duration(end.diff(start)).humanize();

						if (end.diff(start))
							agent_total_status.push({
								agent: it.agent,
								name: name || '',
								status: a.status,
								time: end.diff(start, 'ms'),
							});
						timelineData.push([
							name || '' + it.agent,
							t('' + a.status),
							a.status ? colors[a.status] || colors.other : colors.unknown,
							`${t('status')}: ${t('' + a.status)} <br/>${t('agent')}: ${name || '' + it.agent}<br/>${t('duration')}: ${tooltip}<br/>${t(
								'start'
							)}: ${moment(start).format('DD-MM HH:mm')}<br/>${t('end')}: ${moment(end).format('DD-MM HH:mm')}`,
							start,
							end,
						]);
					});
				} else {
					let tooltip = moment.duration(_end.diff(_start)).humanize();
					if (_end.diff(_start))
						agent_total_status.push({
							agent: it.agent,
							name: name || '',
							status: it.last_status,
							time: _end.diff(_start, 'ms'),
						});
					timelineData.push([
						name || '' + it.agent,
						t('' + it.last_status),
						it.last_status ? colors[it.last_status] || colors.other : colors.unknown,
						,
						`${t('status')}: ${t('' + it.last_status)} <br/>${t('agent')}: ${name || '' + it.agent}<br/>${t('duration')}: ${tooltip}<br/>${t(
							'start'
						)}: ${moment(_start).format('DD-MM HH:mm')}<br/>${t('end')}: ${moment(_end).format('DD-MM HH:mm')}`,
						_start,
						_end,
					]);
				}
			}
		});
		agent_total_status = _.groupBy(agent_total_status, 'agent');
		/* console.log('this.state.agentStatus', agent_total_status);
		console.log('timelineData', timelineData);
		console.log('new_timeline', new_timeline); */
		let main = [
			[
				{ type: 'string', id: 'Position' },
				{ type: 'string', id: 'Name' },
				{ type: 'string', role: 'style', id: 'style' },
				{ type: 'string', role: 'tooltip' },
				{ type: 'date', id: 'Start' },
				{ type: 'date', id: 'End' },
			],
		];
		let agentStatusList = _.concat(main, timelineData);
		//let instagramStatusList = _.concat(main, instagramTimeline);
		//let instagramLength = this.state.instagrams && this.state.instagrams.length;
		console.log('agentList', agent_total_status);
		let showingAgentList;
		if (selectedAgent !== 'all') {
			showingAgentList = _.filter(agentList, { id: selectedAgent });
		} else if (selectedWatsonsGroup !== 'all') {
			showingAgentList = _.filter(agentList, { group: selectedWatsonsGroup });
		} else {
			showingAgentList = agentList;
		}

		let excel_data = _.map(new_timeline, (it) => {
			return _.map(it.changes, (a, i) => {
				let status_name = _.find(agent_statuses, { value: a.status }) ? _.find(agent_statuses, { value: a.status }).title : t(a.status);
				return {
					name: it.name,
					status: status_name || a.status,
					date: moment(a.date).format('DD-MM-YYYY HH:mm:ss'),
				};
			});
		});
		let excel_data2 = _.map(showingAgentList, (it) => {
			let status_array = agent_total_status['yapaytech-' + it.id] || agent_total_status[it.id];
			let name = it.name || it.fullname;
			let email = it.email || it.developer;
			let team_leader_name = it.team_leader_name;
			let team;
			if (it.team) {
				let team_name = _.find(chat_teams, (o) => o.id === it.team);
				if (team_name) team = team_name.label;
			}

			let location_name = it.location_name;
			let sicil = it.sicil;
			/* console.log('status_array', status_array); */
			let available_time = _.sumBy(_.filter(status_array, { status: 'available' }), 'time');
			let busy_time = _.sumBy(_.filter(status_array, { status: 'busy' }), 'time');
			let offline_time = _.sumBy(_.filter(status_array, { status: 'offline' }), 'time');
			let take_conversation_enabled_time = _.sumBy(_.filter(status_array, { status: 'take_conversation_enabled' }), 'time');
			let take_conversation_disabled_time = _.sumBy(_.filter(status_array, { status: 'take_conversation_disabled' }), 'time');
			let others = _.map(agent_statuses, (it) => ({
				title: it.title,
				value: it.value,
				time: this.miliToSec(_.sumBy(_.filter(status_array, { status: it.value }), 'time')),
				raw_time: _.sumBy(_.filter(status_array, { status: it.value }), 'time'),
			}));
			others = _.filter(others, (o) => o.title !== 'offline');
			let mola_time = _.sumBy(
				_.filter(others, (o) => /Kısa Mola|Yemek Molası/.test(o.title)),
				'raw_time'
			);
			let total_time = available_time + _.sumBy(others, 'raw_time');
			let staff_time = total_time - mola_time;
			return {
				email,
				name,
				team_leader_name,
				location_name,
				sicil,
				team,
				available: this.miliToSec(available_time),
				busy: this.miliToSec(busy_time),
				offline_time: this.miliToSec(offline_time),
				..._.mapValues(_.keyBy(others, 'title'), 'time'),
				datetime: `${moment(start_date).format('DD-MM-YYYY HH:mm:ss')} - ${moment(end_date).format('DD-MM-YYYY HH:mm:ss')}`,
				total_time: this.miliToSec(total_time),
				staff_time: this.miliToSec(staff_time),
				mola_time: this.miliToSec(mola_time),
				rate_of_mola_time: total_time ? `${((mola_time / total_time) * 100).toFixed(2)}%` : '-',
				take_conversation_enabled_time: this.miliToSec(take_conversation_enabled_time),
				take_conversation_disabled_time: this.miliToSec(take_conversation_disabled_time),
			};
		});
		console.log('excel_data2', excel_data2);
		let sheets = [
			{
				name: 'agent_status_timeline_detail',
				x: [
					{ title: t('name'), key: 'name' },
					{ title: t('status'), key: 'status' },
					{ title: t('date'), key: 'date' },
				],
				datasets: _.flatten(excel_data),
			},
			{
				name: 'agent_status_timeline_total',
				x: [
					{ title: 'Tarih-Saat', key: 'datetime' },
					{ title: 'isim', key: 'name' },
					{ title: 'Email', key: 'email' },
					{ title: 'Sicil', key: 'sicil' },
					{ title: 'Takım', key: 'team' },
					{ title: 'Takım Lideri', key: 'team_leader_name' },
					{ title: 'Lokasyon', key: 'location_name' },
					{ title: 'Müsait', key: 'available' },
					{ title: 'Meşgul', key: 'busy' },
					{ title: 'Kısa Mola', key: 'Kısa Mola' },
					{ title: 'Yemek Molası', key: 'Yemek Molası' },
					{ title: 'Toplantı', key: 'Toplantı' },
					{ title: 'Backoffice', key: 'Backoffice' },
					{ title: 'offline', key: 'offline_time' },
					{ title: 'Staff', key: 'staff_time' },
					{ title: 'Puantaj', key: 'staff_time' },
					{ title: 'Toplam Mola', key: 'mola_time' },
					{ title: 'Mola Oranı', key: 'rate_of_mola_time' },
					{ title: 'Konuşma Alma Açık', key: 'take_conversation_enabled_time' },
					{ title: 'Konuşma Alma Kapalı', key: 'take_conversation_disabled_time' },
				],
				datasets: _.flatten(excel_data2),
			},
		];
		return (
			<Container>
				<Segment>
					<FilterComponent
						watsons_groups={watsons_groups}
						selectedWatsonsGroup={selectedWatsonsGroup}
						teams={teams}
						selectedTeam={selectedTeam}
						dropAgentList={dropAgentList}
						selectedAgent={selectedAgent}
						product={this.props.product}
						livechat_agent={this.props.user}
						agent_role={this.props.user?.role}
						handleFilterChange={this.handleFilterChange}
						handleFilterCheck={this.handleFilterCheck}
						t={t}
						onFilterChange={this.onFilterChange}
						excelDownload={true}
						pid={this.state.pid}
						start_date={start_date}
						end_date={end_date}
						excelData={sheets}
					/>
					<h3 style={{ textAlign: 'center' }}>{t('agentsTimeline')}</h3>
					<Table>
						<Table.Header>
							<Table.HeaderCell>{t('name')}</Table.HeaderCell>
							<Table.HeaderCell>{t('available')}</Table.HeaderCell>
							<Table.HeaderCell>{t('busy')}</Table.HeaderCell>
							{_.map(agent_statuses, (it) => (
								<Table.HeaderCell>{it.title}</Table.HeaderCell>
							))}
							<Table.HeaderCell>Konuşma Alma Açık</Table.HeaderCell>
							<Table.HeaderCell>Konuşma Alma Kapalı</Table.HeaderCell>
						</Table.Header>
						<Table.Body>
							{_.map(showingAgentList, (it) => {
								let status_array = agent_total_status['yapaytech-' + it.id] || agent_total_status[it.id];
								/* console.log('status_array', status_array); */
								let available_time = _.sumBy(_.filter(status_array, { status: 'available' }), 'time');
								let busy_time = _.sumBy(_.filter(status_array, { status: 'busy' }), 'time');
								let take_conversation_enabled_time = _.sumBy(_.filter(status_array, { status: 'take_conversation_enabled' }), 'time');
								let take_conversation_disabled_time = _.sumBy(_.filter(status_array, { status: 'take_conversation_disabled' }), 'time');
								let others = _.map(agent_statuses, (it) => ({
									title: it.title,
									value: it.value,
									time: _.sumBy(_.filter(status_array, { status: it.value }), 'time'),
								}));
								if (it.developer)
									return (
										<Table.Row>
											<Table.Cell>{it.developer}</Table.Cell>
											<Table.Cell>{this.miliToSec(available_time)}</Table.Cell>
											<Table.Cell>{this.miliToSec(busy_time)}</Table.Cell>
											{_.map(others, (it) => (
												<Table.Cell>{this.miliToSec(it.time)}</Table.Cell>
											))}
											<Table.Cell>{this.miliToSec(take_conversation_enabled_time)}</Table.Cell>
											<Table.Cell>{this.miliToSec(take_conversation_disabled_time)}</Table.Cell>
										</Table.Row>
									);
							})}
						</Table.Body>
					</Table>
				</Segment>
				{process.env.NODE_ENV !== 'production' && (
					<div>
						<pre>{JSON.stringify(agentStatusList, null, 2)}</pre>
					</div>
				)}
			</Container>
		);
	}
}
const stateToProps = (state) => ({ access: state.access, location: state.router.location, product: state.product, user: state.access.user.loggedUserObj });

export default connect(stateToProps)(withTranslation()(Analytic));
